export default class CanalModel {
  constructor(id = 0, nome = '', descricao = '', canalTipoId = 0) {
    this.id = id
    this.nome = nome
    this.descricao = descricao
    this.canalTipoId = canalTipoId
  }
}
